import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export interface LinkPartnerRequest {
  partner: string;
  partnerAccessToken: string;
  partnerIdToken: string;
}

export const linkPartnerRequest = async (requestBody: LinkPartnerRequest) => {
  try {
    const result = await post('/guest/link/partner', {
      body: JSON.stringify(requestBody),
    });

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
};
